define.alias("shared/helpers/profile-color-class", "media/helpers/profile-color-class");